import styled from '@emotion/styled';

import { Breakpoints } from 'utils/const.styles';

export const Form = styled.form`
	background-color: var(--white);
	padding: 1rem;
	border: 1px solid var(--border-color);
	border-radius: var(--small-border-radius);
	overflow: auto;
	display: flex;
	flex-wrap: wrap;
	width: 100%;

	> .typography {
		margin-left: var(--margin-2);
	}

	&.borderless {
		padding: 0;
		border: none;
		border-radius: 0;
		background-color: transparent;
	}
	&.block {
		display: block;
	}
	@media print {
		padding: 2rem;
		padding-top: 1rem;
		border: none;
	}
	.formInfoArea {
		padding: 0 !important;
	}
	&.credentials {
		@media ${Breakpoints.mobile} {
			padding: 0 !important;
			margin-bottom: 10rem;
		}
	}
	@media ${Breakpoints.mobile} {
		&.borderless {
			padding: var(--padding-2) var(--padding-3);
		}
		padding: var(--padding-2) var(--padding-3);
		border: none;
	}
`;

export const FlagOptionContainer = styled.div`
	display: flex;
	flex-direction: row;
	align-items: center;
	gap: 1rem;
	padding: 0 0.5rem;
	&.selected {
		gap: 0.5rem;
	}
`;

export const TemplateSelectorContainer = styled.div`
	display: flex;
	@media ${Breakpoints.tablet} {
		display: block;

		> div {
			width: 100%;
			img {
				width: 100%;
				height: auto;
			}

			span {
				color: var(--black);
				width: 100%;
				svg {
					width: 2rem !important;
					height: 2rem !important;
					padding: 1.5rem;
				}
			}
		}
	}
`;
export const PoweredByOTO = styled.div`
	display: none;
	justify-content: center;
	position: fixed;
	bottom: 1rem;
	left: 50%;
	transform: translateX(-50%);
	align-items: center;
	padding-top: 2rem;

	img {
		width: 26px;
		margin: 0 0.5rem;
	}
	@media print {
		display: flex !important;
		margin-top: 2rem;
	}
`;

export const Line = styled.span`
	height: 1px;
	min-height: 1px;
	background-color: var(--border-color);
	width: 100%;

	margin: 1rem auto;
	display: block;

	@media ${Breakpoints.mobile} {
		margin: 1.5rem auto;
	}
`;

export const NonFormContainer = styled.div`
	display: flex;
	flex-direction: column;
	width: 100%;
	background: var(--white);
	padding: var(--padding-4);
	border: 1px solid var(--border-color);
	border-radius: var(--small-border-radius);
`;

export const TabsFormContainer = styled.div`
	border: 1px solid var(--border-color);
	background-color: var(--white);
	display: flex;
	flex-wrap: wrap;
	padding: 1rem;
	width: 100%;

	@media ${Breakpoints.mobile} {
		padding: 0 var(--padding-3);
		border: 0 none;
	}
`;

export const FormModalFooter = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: right;
	padding: 2rem 1rem 0 1rem;
	border-top: 1px solid var(--border-color);

	body[dir='rtl'] & {
		justify-content: left;
	}

	@media ${Breakpoints.mobile} {
		margin: 0;
		padding: var(--padding-3) var(--padding-3) var(--padding-3) var(--padding-3);
		box-shadow: 1px -2px 2px 0px rgba(0, 0, 0, 0.05);
	}
`;

export const FormFooter = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: flex-end;
	align-items: center;
	gap: 1rem;
	padding: 1rem;
	background-color: var(--white);
	width: -webkit-fill-available;
	min-height: 6.15rem;

	body[dir='rtl'] & {
		justify-content: left;

		.icon {
			transform: scaleX(-1);
		}
	}

	@media ${Breakpoints.tablet} {
		padding: 1.5rem 2rem;
		border: 1px solid var(--border-color);
		border-radius: 0 0 var(--small-border-radius) var(--small-border-radius);
	}

	@media ${Breakpoints.mobile} {
		position: fixed;
		bottom: 0;
		left: 0;
		right: 0;
		padding: 1.5rem 1rem;
		border: none;
		border-radius: 0;
		box-shadow: 1px -2px 2px 0px rgba(0, 0, 0, 0.05);
	}

	@media (min-width: 991.98px) {
		display: none !important;
	}
`;

export const RadioItem = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: flex-start;
	align-items: center;
	width: 100%;
	min-height: 3rem;
	padding-block: var(--padding-1);
	z-index: var(--z-index-1);
	cursor: pointer;

	> .typography {
		color: var(--black);
		margin-inline: var(--margin-2);

		body[dir='rtl'] & {
			margin-left: unset;
			margin-inline: var(--margin-2);
		}
	}

	input {
		cursor: pointer;
	}

	${({ disabled }) => `
      cursor: ${disabled ? 'not-allowed' : 'pointer'};
      pointer-events: ${disabled ? 'none' : 'auto'};
      `}
`;

export const FormItemContainer = styled.div`
	display: flex;
	flex-wrap: wrap;
	width: 100%;
	justify-content: ${({ justifyContent }) => justifyContent};
	padding-left: ${({ noLeftPadding }) => (noLeftPadding ? '0' : '1rem')};

	.map-field {
		display: flex;
		flex-direction: column-reverse;
		width: 100%;
		gap: 1.5rem;

		> div:first-of-type {
			height: 252px !important;
		}
	}
	@media ${Breakpoints.mobileLandscape} {
		> div {
			width: 100%;
		}
	}
`;

export const InfoWrapper = styled.div`
	display: flex;
	flex-direction: row;
	align-items: center;
`;

export const TooltipContainer = styled.div`
	display: flex;
	flex-direction: column;
	height: 100%;
	max-width: 333px;
`;

export const BoldText = styled.span`
	font-weight: 700;
`;

export const RadioLabelContainer = styled.div`
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: center;
	padding-left: 1rem;

	.typography {
		padding-right: 4px;

		@media ${Breakpoints.mobileLandscape} {
			padding-right: 2px;
		}
	}

	.icon {
		padding-right: 8px;

		@media ${Breakpoints.mobileLandscape} {
			padding-right: 4px;
		}
	}

	.pill {
		cursor: default;
	}
`;
